export const AUTH_TOKEN = 'auth-token';
export const USER_NAME = 'user-name';

export const questions = [
  { question: 'what should i do?' },
  { question: 'what should i watch?' },
  { question: 'where should i eat?' },
  { question: 'what should i cook?' },
  { question: 'what else could i do?' }
];
